/**
 * Minimal ULID. ~30 lines instead of a dependency, because it lands in the
 * 150 KB client budget (ADR-0003).
 *
 * Message ids are generated on the client: they sort by creation time, and a
 * retried send is idempotent because the id already exists server-side.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford base32, no I/L/O/U
const TIME_LEN = 10;
const RANDOM_LEN = 16;
function randomBytes(n) {
    const b = new Uint8Array(n);
    globalThis.crypto.getRandomValues(b);
    return b;
}
function encodeTime(now) {
    let out = '';
    for (let i = TIME_LEN - 1; i >= 0; i--) {
        out = ALPHABET[now % 32] + out;
        now = Math.floor(now / 32);
    }
    return out;
}
function encodeRandom() {
    const bytes = randomBytes(RANDOM_LEN);
    let out = '';
    for (let i = 0; i < RANDOM_LEN; i++)
        out += ALPHABET[bytes[i] % 32];
    return out;
}
export function ulid(seedTime = Date.now()) {
    return encodeTime(seedTime) + encodeRandom();
}
/** Milliseconds encoded in the id — lets us sort or expire without a timestamp column. */
export function ulidTime(id) {
    let t = 0;
    for (let i = 0; i < TIME_LEN; i++)
        t = t * 32 + ALPHABET.indexOf(id[i]);
    return t;
}
export function isUlid(s) {
    return /^[0-9A-HJKMNP-TV-Z]{26}$/.test(s);
}
//# sourceMappingURL=ulid.js.map